import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classes from './CertificateDetailsRPLinkButton.module.scss'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { RPAttachmentLinkButtonEnum } from '../../../add-new-certificate/rp-library/shared/constants/AddAttachmentsRPConstants'
import clsx from 'clsx'

interface ICertificateDetailsRPLinkButtonProps {
  className?: string
  onClick?: () => void
  label: string
  icon: IconProp
  linkButtonType: RPAttachmentLinkButtonEnum
}
const CertificateDetailsRPLinkButton = (props: ICertificateDetailsRPLinkButtonProps) => {
  return (
    <span
      className={clsx(
        classes['text-btn'],
        { [classes['unlinkEcm']]: props.linkButtonType === RPAttachmentLinkButtonEnum.unlinkEcm },
        {
          [classes['linkToWbAndEcm']]:
            props.linkButtonType === RPAttachmentLinkButtonEnum.linkToWbAndEcm,
        },
        { [classes['linkToWb']]: props.linkButtonType === RPAttachmentLinkButtonEnum.linkToWb }
      )}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onClick?.();

      }}
      title={props.label}
      style={{ overflowY: 'hidden' }}
    >
      <FontAwesomeIcon className={classes['icons']} icon={props.icon} />
      {props.label}
    </span>
  )
}

export default CertificateDetailsRPLinkButton
